module.exports = __webpack_public_path__ + "static/logo-no-pad-b717e5f85ebce06be1d7ee1e27c1f828.svg";